module.exports = __webpack_public_path__ + "img/Line.708d3ed3.svg";